import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HrDashboardService } from '../../../service/hr-dashboard/hr-dashboard.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-dialog-all-claim-report',
  templateUrl: './dialog-all-claim-report.component.html',
  styleUrls: ['./dialog-all-claim-report.component.scss']
})
export class DialogAllClaimReportComponent implements OnInit {

  policyYears = [];
  reportTypes = [];
  reportByCategories = [];

  inputForm = this.fb.group({
    policyYearId: [null, [Validators.required]],
    reportType: [null, [Validators.required]],
    reportFor: [null, [Validators.required]]
  });

  constructor(
    public dialogRef: MatDialogRef<DialogAllClaimReportComponent>,
    private hrDashboardService: HrDashboardService,
    private messageService: MessageService,
    private enumService: EnumService,
    private fb: FormBuilder,
    private fileHandlerService: FileHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.policyYears = data.policyYears;
  }

  ngOnInit() {
    this.getReportTypes();
    this.getAllClaimReportByCategories();
  }

  onCancel() {
    this.dialogRef.close('no');
  }

  getAllClaimReport() {
    this.messageService.confirm().then(con => {
      if (con.value === true) {
        this.downloadReport(this.inputForm.value);
      }
    });
  }

  downloadReport(formData: any) {
    let payload = {
      groupPolicyId: this.data.groupPolicyId,
      groupPolicyAnniversaryId: formData.policyYearId,
      reportType: formData.reportType,
      reportFor: formData.reportFor
    }

    this.hrDashboardService.sendEmailForAllClaimReport(payload).subscribe((response: any) => {
      //this.downloadParseExcel(response);
      this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
    }, error => {
      this.messageService.show(error.error.message, 'error');
    });
  }

  downloadParseExcel(response): void {
    if (response.file) {
      const binary = atob(response.file);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) { array[i] = binary.charCodeAt(i); }
      this.fileHandlerService.downloadExcel(array, response.filename + ".xlsx");
    } else {
      this.messageService.show(response.message, 'error');
    }
  }

  getReportTypes() {
    this.enumService.getHrDashboardClaimsReportType().subscribe(res => {
      this.reportTypes = res;
    }, error => {
      this.messageService.show(error.error.message, 'error');
    });
  }

  private getAllClaimReportByCategories(): void {
    this.enumService.getAllClaimReportByCategories().subscribe(res => {
      this.reportByCategories = res;
    },
    err => {
      this.messageService.show(err.error.message, "error");
    });
  }
}
